module.exports.SERVER_API_URL = "https://localhost:44313/api";
module.exports.SERVER_SIGNALR_URL = "https://localhost:44313";
module.exports.CLIENT_URL = "http://localhost:3000";